import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { getErrorMessage } from '../../utils/helper';

export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/account');
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch accounts'));
    }
  }
);

export const addTransaction = createAsyncThunk(
  'accounts/addTransaction',
  async (transactionData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/transaction', transactionData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to add transaction'));
    }
  }
);

export const fetchTransactions = createAsyncThunk(
  'accounts/fetchTransactions',
  async ({ accountId, startDate, endDate, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/transaction', {
        params: {
          accountId,
          startDate,
          endDate,
          page,
          limit
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error,'Failed to fetch transactions'));
    }
  }
); 